import { render, staticRenderFns } from "./JobRolesUpdateModal.vue?vue&type=template&id=08f35266&"
import script from "./JobRolesUpdateModal.vue?vue&type=script&lang=js&"
export * from "./JobRolesUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports